// Beispiel: ContactFormBlock.js
import { registerBlockType } from "@wordpress/blocks";
import config, { type BlockAttributes } from "./block.json";
import FormEditor from "./FormEditor";
import FormSave from "./FormSave";

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  edit: FormEditor,
  save: FormSave,
});
